/* eslint-disable */
// import {
//     Row,
//     Col,
//     Button,
//     Modal,
//     Breadcrumb,
//     Card,
//     Form,
//   } from "react-bootstrap";
  import DataTable from "react-data-table-component";
  import React from "react";
  import * as Icon from "react-bootstrap-icons";
  
  import "./Contacts.css";
  
  import { useState, useEffect, useCallback } from "react";
  import { useParams, useNavigate } from "react-router";
  
  //Redux-imports 
  import { useDispatch, useSelector } from "react-redux";
//   import { addContact } from "../../../../../redux/actions/crmActions";
  
  const AddAccounts = (props) => {
    // const { pageFrom } = props;
    // const { id } = useParams(); 
    const dispatch = useDispatch();
    const navigate = useNavigate();
  
    const [fname, setFname] = useState("");
    const [lname, setLname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [city, setCity] = useState("");
    const [designation, setDesignation] = useState("");
    const [company, setCompany] = useState("");
    const [companyWebsite, setCompanyWebsite] = useState("");
  
    // const contactDetails = useSelector((state) => state.crmLeads.contactDetails);
  
    // props.pageTypeHandler("CRM"); 
  
    
  
    // const submitHandler = async (e) => {
    //   e.preventDefault();
  
    //   let newContact;
    //   if (contactDetails) {
    //     if (pageFrom === "Contacts") {
    //       newContact = {
    //         contact_id: contactDetails.contact_id,
    //         fname: fname,
    //         lname: lname,
    //         company: company,
    //         company_web: companyWebsite,
    //         email: email,
    //         designation: designation,
    //         city: city,
    //         phone: phone,
    //       };
    //     } else if (pageFrom === "Prospects") {
    //       newContact = {
    //         known: 1,
    //         contact_id: contactDetails.contact_id,
    //         fname: fname,
    //         lname: lname,
    //         company: company,
    //         company_web: companyWebsite,
    //         email: email,
    //         designation: designation,
    //         city: city,
    //         phone: phone,
    //       };
    //     }
    //   } else {
    //     if (pageFrom === "Contacts") {
    //       newContact = {
    //         fname: fname,
    //         lname: lname,
    //         company: company,
    //         company_web: companyWebsite,
    //         email: email,
    //         designation: designation,
    //         city: city,
    //         phone: phone,
    //       };
    //     } else if (pageFrom === "Prospects") {
    //       newContact = {
    //         known: 1,
    //         fname: fname,
    //         lname: lname,
    //         company: company,
    //         company_web: companyWebsite,
    //         email: email,
    //         designation: designation,
    //         city: city,
    //         phone: phone,
    //       };
    //     }
    //   }
  
    //   dispatch(addContacts(props.authToken, newContact));
    //   setTimeout(() => {
    //    navigate(-1);
    //   }, 2000);
    // };
  
    // useEffect(() => {
    //   if (contactDetails) {
    //     setFname(contactDetails.fname);
    //     setLname(contactDetails.lname);
    //     if(contactDetails?.company?.comapny_name){
    //       setCompany(contactDetails?.company?.company_name);
    //     }else{
    //       setCompany(contactDetails?.company);
    //     }
        
    //     setCompanyWebsite(contactDetails.company_web);
    //     setEmail(contactDetails.email);
    //     setDesignation(contactDetails.designation);
    //     setCity(contactDetails.city);
    //     setPhone(contactDetails.phone);
    //   }
    // }, []);
  
   
  
    return (
      <>
        <div className="sub-header">
          <div className="grid grid-cols-12">
            <div className="header-breadcrumb px-5">
              {/* <Breadcrumb> */}
                {/* <Breadcrumb.Item> */}
                  <div>Back</div>
                {/* </Breadcrumb.Item> */}
                <span>
                  <Icon.ChevronRight />
                </span>
              {/* </Breadcrumb> */}
            </div>
          </div>
        </div>
        <div className="new-contact mt-4">
          <div className="container contacts-view">
            <div className="grid grid-span-12">
              <div>
                <div>
                  <div>
                    {/* {contactDetails ? (
                      <Card.Title>
                        Edit {pageFrom === "Contacts" ? "Contact" : "Prospect"}
                      </Card.Title>
                    ) : (
                      <Card.Title>
                        New {pageFrom === "Contacts" ? "Contact" : "Prospect"}
                      </Card.Title>
                    )} */}
                    <div className="mt-4 mb-4">
                      {/* <Form onSubmit={submitHandler}> */}
                      <form >
                        <div className="grid grid-cols-12">
                          <div className="col-span-5">
                            <h6 className="mb-3">Personal Information</h6>
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">
                                    First Name
                                    {/* <span className="mandatory">*</span> */}
                                  </label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    required
                                    placeholder="Firstname"
                                    value={fname}
                                    onChange={(e) => setFname(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
  
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">
                                    Last Name
                                  </label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="text"
                                    //ref={nameRef}
                                    required
                                    placeholder="Last Name"
                                    value={lname}
                                    onChange={(e) => setLname(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
  
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">Email</label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="email"
                                    //ref={nameRef}
                                    required
                                    autoComplete="off"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
  
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">
                                    Phone Number
                                  </label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="tel"
                                    //ref={nameRef}
                                    required
                                    autoComplete="off"
                                    placeholder="Phone Number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
  
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">City</label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="text"
                                    //ref={nameRef}
                                    autoComplete="off"
                                    placeholder="City"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
  
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">
                                    Designation
                                  </label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="text"
                                    //ref={nameRef}
                                    autoComplete="off"
                                    placeholder="Designation"
                                    value={designation}
                                    onChange={(e) =>
                                      setDesignation(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
  
                          <div className="col-span-2"></div>
  
                          <div className="col-span-5">
                            <h6 className="mb-3">Company Information</h6>
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">
                                    Company Name
                                  </label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="text"
                                    //ref={nameRef}
                                    autoComplete="off"
                                    placeholder="Company Name"
                                    value={company}
                                    onChange={(e) => setCompany(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
  
                            <div className="mb-3">
                              <div className="grid grid-cols-12">
                                <div className="col-span-4">
                                  <label className="mt-1">
                                    Company Website
                                  </label>
                                </div>
                                <div className="col-span-8">
                                  <input
                                    type="text"
                                    //ref={nameRef}
                                    autoComplete="off"
                                    placeholder="Company Website"
                                    value={companyWebsite}
                                    onChange={(e) =>
                                      setCompanyWebsite(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
  
                        {/* {contactDetails ? (
                          <div
                            variant="info"
                            type="submit"
                            className="save-proceed-btn"
                          >
                            Update{" "}
                            {pageFrom === "Contacts" ? "Contact" : "Prospect"}
                            <span>
                              <Icon.ChevronRight />
                            </span>
                          </div>
                        ) : (
                        )} */}
                          <div
                            variant="info"
                            type="submit"
                            className="save-proceed-btn"
                          >
                            Add 
                            <span>
                              <Icon.ChevronRight />
                            </span>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default AddAccounts;
  